<div class="user-preferences">
	<div class="wrapper">
		<div class="menu">
			@if (loaded()) {
			<button class="button-customize" [ngClass]="{ active: !showPreferences() }" (click)="showPreferences.set(false)">
				<ng-icon class="icon-menu-preferences" [svg]="icons['customize']" />
				<span>{{ 'MENU.USER.CUSTOMIZE' | translate }}</span>
			</button>
			<button class="button-preferences" [ngClass]="{ active: showPreferences() }" (click)="showPreferences.set(true)">
				<ng-icon class="icon-menu-preferences" [svg]="icons['preferences']" />
				<span>{{ 'PREFERENCES.TITLE' | translate }}</span>
			</button>
			}
		</div>
		<div class="content">
			@if (!loaded()) {
			<unir-ai-loading></unir-ai-loading>
			} @else {

			<div class="header">
				<button (click)="onCancel()">
					<ng-icon class="icon-close" [svg]="icons['close']" />
				</button>
				@if (!showPreferences()) {
				<h2 class="user-name">{{ student()?.fullname }}</h2>
				} @else {
				<div class="theme">
					<label>{{ 'PREFERENCES.COLOR' | translate }}</label>
					<div>
						<button
							class="button-theme"
							[ngClass]="{ active: !this.darkThemeService.isDarkTheme() }"
							(click)="darkThemeService.changeThemeMode(false)"
						>
							<span><ng-icon class="icon-theme" [svg]="icons['light']" /> {{ 'PREFERENCES.LIGHT' | translate }}</span>
							<img src="./../../../assets/img/unir-light.svg" alt="{{ 'PREFERENCES.LIGHT' | translate }}" />
						</button>
						<button
							class="button-theme"
							[ngClass]="{ active: this.darkThemeService.isDarkTheme() }"
							(click)="darkThemeService.changeThemeMode(true)"
						>
							<span><ng-icon class="icon-theme" [svg]="icons['dark']" /> {{ 'PREFERENCES.DARK' | translate }}</span>
							<img src="./../../../assets/img/unir-dark.svg" alt="{{ 'PREFERENCES.DARK' | translate }}" />
						</button>
					</div>
				</div>
				<div class="language">
					<label>{{ 'PREFERENCES.SELECT_LANGUAGE' | translate }}</label>
					<div class="select-wrapper">
						<select [ngModel]="translate.currentLang" (ngModelChange)="changeLanguage($event)">
							@for (lang of languages; track lang.code) {
							<option [value]="lang.code">{{ lang.name }}</option>
							}
						</select>
					</div>
				</div>
				}
			</div>
			@if (!showPreferences()) {
			<div class="nickname">
				<label>{{ 'PREFERENCES.NICKNAME' | translate }}</label>
				<input
					pInputText
					[(ngModel)]="nickModel"
					[maxlength]="maxCharNick"
					placeholder="{{ 'PREFERENCES.NICKNAME_PLACEHOLDER' | translate }}"
				/>
			</div>
			<div class="qualities">
				<label>{{ 'PREFERENCES.QUALITIES' | translate }}</label>
				<textarea
					[(ngModel)]="qualitiesModel"
					[maxlength]="maxCharQualities"
					[autoResize]="true"
					placeholder="{{ 'PREFERENCES.QUALITIES_PLACEHOLDER' | translate }}"
					pInputTextarea
					rows="4"
				></textarea>
				<span class="char-counter"
					>{{ qualitiesModel.length || 0 }} / 250 {{ 'PREFERENCES.CHARACTERS' | translate }}</span
				>
			</div>
			<div class="pills">
				@for (pill of pills(); track pill.id) {
				<button class="pill" (click)="onPillClick(pill.description)">
					<ng-icon class="icon-pill" [svg]="icons['plus']" /> {{ pill.name }}
				</button>
				}
			</div>
			}
			<div class="footer">
				<button (click)="onCancel()">{{ 'PREFERENCES.CANCEL' | translate }}</button>
				<button (click)="onSave()">{{ 'PREFERENCES.SAVE' | translate }}</button>
			</div>
			}
		</div>
	</div>
</div>
